import { render, staticRenderFns } from "./DetailSplitDialog.vue?vue&type=template&id=6dd7ee48&scoped=true"
import script from "./DetailSplitDialog.vue?vue&type=script&lang=js"
export * from "./DetailSplitDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailSplitDialog.vue?vue&type=style&index=0&id=6dd7ee48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7ee48",
  null
  
)

export default component.exports